// The Tasks Variable will be replaced in the future with a DB fetch
export const Tasks = [
    {
        name: 'Project Planning',
        number: 1,
        index: 1,
        costLevel: 'medium',
        twoSides: true,
        orTask: 'Project High-level Planning',
        constraint: 1,
        relationships: [],
        isChecked: false,
    },
    {
        name: 'Functional Specification of the Website',
        number: 2,
        index: 2,
        costLevel: 'low',
        twoSides: true,
        orTask: 'Short Functional Specification',
        constraint: 1,
        relationships: [],
        isChecked: false,
    },
    {
        name: 'Detailed SEO Specification',
        number: 3,
        index: 3,
        costLevel: 'medium',
        twoSides: true,
        orTask: 'General SEO Requirements',
        constraint: 1,
        relationships: [2],
        isChecked: false,
    },
    {
        name: 'Setup Dev. Environment',
        number: 4,
        index: 4,
        costLevel: 'very low',
        twoSides: false,
        orTask: false,
        constraint: 1,
        relationships: [],
        isChecked: false,
    },
    {
        name: 'Design UI/UX',
        number: 5,
        index: 5,
        costLevel: 'standard',
        twoSides: true,
        orTask: 'Use UX General Guidelines',
        constraint: false,
        relationships: [2],
        isChecked: false,
    },
    {
        name: 'Design Website Templates',
        number: 6,
        index: 6,
        costLevel: 'low',
        twoSides: true,
        orTask: 'Use Existing Templates',
        constraint: false,
        relationships: [2, 4],
        isChecked: false,
    },
    {
        name: 'Install Plugins and Addons',
        number: 7,
        index: 7,
        costLevel: 'very low',
        twoSides: false,
        orTask: false,
        constraint: false,
        relationships: [3, 4],
        isChecked: false,
    },
    {
        name: 'Develop Website Map',
        number: 8,
        index: 8,
        costLevel: 'very low',
        twoSides: false,
        orTask: false,
        constraint: false,
        relationships: [2],
        isChecked: false,
    },
    {
        name: 'Design Graphic Elements',
        number: 9,
        index: 9,
        costLevel: 'standard',
        twoSides: true,
        orTask: 'Use Existing Graphic Elements',
        constraint: false,
        relationships: [2, 5],
        isChecked: false,
    },
    {
        name: 'Develop Website Content',
        number: 10,
        index: 10,
        costLevel: 'high',
        twoSides: false,
        orTask: false,
        constraint: false,
        relationships: [5],
        isChecked: false,
    },
    {
        name: 'Upload Content to the Website',
        number: 11,
        index: 11,
        costLevel: 'low',
        twoSides: false,
        orTask: false,
        constraint: false,
        relationships: [5],
        isChecked: false,
    },
    {
        name: 'Setup Testing Environment',
        number: 12,
        index: 12,
        costLevel: 'very low',
        twoSides: false,
        orTask: false,
        constraint: false,
        relationships: [5, 7],
        isChecked: false,
    },
    {
        name: 'Perform Functional Tests',
        number: 13,
        index: 13,
        costLevel: 'standard',
        twoSides: true,
        orTask: 'Perform Quick Functional Tests',
        constraint: false,
        relationships: [6, 7, 8, 11, 12],
        isChecked: false,
    },
    {
        name: 'Perform Content Tests',
        number: 14,
        index: 14,
        costLevel: 'low',
        twoSides: true,
        orTask: 'Perform Quick Content Tests',
        constraint: false,
        relationships: [11],
        isChecked: false,
    },
    {
        name: 'Perform Performance Tests',
        number: 15,
        index: 15,
        costLevel: 'very low',
        twoSides: true,
        orTask: 'Perform Quick Performance Tests',
        constraint: false,
        relationships: [12],
        isChecked: false,
    },
    {
        name: 'Setup Production Environment',
        number: 16,
        index: 16,
        costLevel: 'very low',
        twoSides: false,
        orTask: false,
        constraint: false,
        relationships: [13],
        isChecked: false,
    },
    {
        name: 'Go Live',
        number: 17,
        index: 17,
        costLevel: 'high',
        twoSides: false,
        orTask: false,
        constraint: false,
        relationships: [13, 14, 15, 16],
        isChecked: false,
    },
    {
        name: 'SEO and PPC Advertising',
        number: 18,
        index: 18,
        costLevel: 'standard',
        twoSides: false,
        orTask: false,
        constraint: false,
        relationships: [17],
        isChecked: false,
    },
];
